import {
	baseUrl
} from "./url.js"

function objByUrl(paramObj) {
	function filter(str) { // 特殊字符转义
		str += ''; // 隐式转换
		str = str.replace(/%/g, '%25');
		str = str.replace(/\+/g, '%2B');
		str = str.replace(/ /g, '%20');
		str = str.replace(/\//g, '%2F');
		str = str.replace(/\?/g, '%3F');
		str = str.replace(/&/g, '%26');
		str = str.replace(/\=/g, '%3D');
		str = str.replace(/#/g, '%23');
		return str;
	}
	const sdata = [];
	for (let attr in paramObj) {
		sdata.push(`${attr}=${filter(paramObj[attr])}`);
	}
	return sdata.join('&');
}
export default function({
	url,
	data,
	header,
	method,
	needDeviceId = true , //是否需要 deviceId
	needToken = true, //是否需要token
	isLoading = true //是否开启loading
}) {
	if (isLoading) {
		uni.showLoading({
			title: '加载中',
			mask: true
		})
	}
	const token = uni.getStorageSync('userInfo');
   let  aa= uni.getStorageSync('systemInfo')
	let userSystem =''
	if(uni.getStorageSync('systemInfo').system.includes('iOS')){
		userSystem = 'ios'
	}else{
		userSystem = 'Android'
	}
	// 操作日志  登录接口需要
	if(header.Authorization){
		header['VirtualClient']= JSON.stringify(
		{
			"loginType": "2", // 1.pc 2.wechat_mini  3:app',
			"userSystem": userSystem,  // windows max Android ios',
			"browser": "Chrome"  //  Chrome   IE',
		})
	
	}
	if(uni.getStorageSync('systemInfo').deviceId){
		var deviceId = uni.getStorageSync('systemInfo').deviceId;
	}
	if (method === 'GET' && data) {
		url = `${url}?${objByUrl(data)}`;
	}
	let tokenInfo = uni.getStorageSync('tokenInfo');
	if(needToken){
		header['Authorization']= 'Bearer' + ' ' + tokenInfo.access_token
		
	}
	if(needDeviceId){
		header['deviceId']= deviceId
	}
	return new Promise((resolve, reject) => {
		uni.request({
			url: baseUrl + url,
			data,
			method,
			timeout: 30 * 1000,
			header,
			success(res) {
				let data = res.data;
				if (data.code == 500 || data.status == 500) {
					// uni.showToast({
					// 	title: data.message ? data.message : '',
					// 	icon: 'none',
					// 	duration:2000
					// })
					// reject(data);
					// return;
				}
				if (data.code == 401) {
					console.log('登录失效')
					// uni.showModal({
					// 	title: '登录已失效，请重新登录',
					// 	success(isLoginUser) {
					// 		if (isLoginUser.confirm) {
					// 			uni.navigateTo({
					// 				url: '/pages/login/login'
					// 			})
					// 		}
					// 	}
					// })
					// reject(data);
					// return;
				}
				if (isLoading){
					uni.hideLoading();
				}
				resolve(data);
			},
			fail(error) {
				uni.showToast({
					title: '连接超时，请检查网络',
					icon: 'none'
				})
				reject(error);
			},
			complete() {
				// uni.hideLoading();
			}
		})
	})
}
